module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "fmhd"
  }, [_c('b', [_vm._v("DEDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It’s amazing what a few fragments of time, fabric, photos, and words can turn into. I would never be writing this book if it weren’t for all of the people I have met in the twenty years since I put my first Fragment out into the world. This book is dedicated to everyone I’ve crossed paths with, whether in a classroom; at a show; through my art and words in books, magazines, or newsletters; or online. It’s dedicated to those who inspired, encouraged, and supported me—directly or indirectly, knowingly or unknowingly—from the very beginning, midway, through the ups and downs, recently, and just now as you read this book. If I have forgotten anyone, I apologize. It has been a wild, crazy ride, and it’s not over yet.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg3_1.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15e71536","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_dedication.vue
// module id = 63
// module chunks = 0